/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* Minimum order message: hide once the cart total reaches the minimum (see snippets/minimum-order-message.liquid) */
(function () {
  function updateMinimumOrderMessages() {
    var messages = document.querySelectorAll('.minimum-order-message[data-minimum-cents]');
    if (!messages.length) return;

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        messages.forEach(function (message) {
          message.hidden = cart.total_price >= parseInt(message.getAttribute('data-minimum-cents'), 10);
        });
      })
      .catch(function () {});
  }

  ['product:added', 'cart:refresh', 'cart:rerendered'].forEach(function (eventName) {
    document.addEventListener(eventName, updateMinimumOrderMessages);
  });

  // Covers pages served from cache or restored via back/forward with a stale cart total
  window.addEventListener('pageshow', updateMinimumOrderMessages);
})();


/* ==========================================================================
   Product Card Add to Cart & Live Syncing Quantity Selector
   ========================================================================== */
(function () {
  if (customElements.get('card-qty-selector')) return;

  var syncTimeout = null;
  window._cartKeyByVariant = window._cartKeyByVariant || {};

  function scheduleCartSync() {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(fetchAndSyncCart, 60);
  }

  function calculateDisplayQty(actualQty, baseUnitMin) {
    if (!baseUnitMin || baseUnitMin <= 1) return actualQty;
    var raw = actualQty / baseUnitMin;
    var rounded = Math.round(raw * 10) / 10;
    return rounded % 1 === 0 ? rounded : Number(rounded.toFixed(1));
  }

  function applyCartSync(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    var selectors = document.querySelectorAll('card-qty-selector');
    var variantManagers = document.querySelectorAll('card-variant-manager');

    var qtyByVariant = {};
    var baseUnitByVariant = {};
    var displayUnitByVariant = {};
    var keyByVariant = {};

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var vId = String(item.variant_id);
      qtyByVariant[vId] = (qtyByVariant[vId] || 0) + item.quantity;
      keyByVariant[vId] = item.key;
      window._cartKeyByVariant[vId] = item.key;

      if (item.properties) {
        if (item.properties._base_unit_min) {
          baseUnitByVariant[vId] = parseFloat(item.properties._base_unit_min);
        }
        if (item.properties._display_unit) {
          displayUnitByVariant[vId] = item.properties._display_unit;
        }
      }
    }

    // Sync individual card-qty-selector elements
    selectors.forEach(function (el) {
      var vId = String(el.getAttribute('data-variant-id'));
      var baseUnitMin = parseFloat(el.getAttribute('data-base-unit-min')) || baseUnitByVariant[vId] || 1;
      var displayUnit = el.getAttribute('data-display-unit') || displayUnitByVariant[vId] || '';
      if (displayUnit === 'meter' && baseUnitMin <= 1) {
        baseUnitMin = 2;
      }
      var actualQty = qtyByVariant[vId] || 0;
      var displayQty = calculateDisplayQty(actualQty, baseUnitMin);
      var itemKey = keyByVariant[vId] || '';
      el.syncQuantity(displayQty, actualQty, itemKey);
    });

    // Sync multi-variant managers
    variantManagers.forEach(function (vm) {
      vm.syncTotal(qtyByVariant, baseUnitByVariant, displayUnitByVariant, keyByVariant);
    });
  }

  function fetchAndSyncCart() {
    var cartUrl = (window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart') + '.js';
    fetch(cartUrl, {
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        applyCartSync(cart);
      })
      .catch(function (err) {
        console.error('[CardQtySync] Error fetching cart:', err);
      });
  }

  function refreshThemeCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    var miniCartUrl = (window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart') + '?section_id=mini-cart';
    fetch(miniCartUrl, {
      credentials: 'same-origin',
      headers: { 'Cache-Control': 'no-cache' }
    })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newMiniCart = temp.querySelector('.mini-cart');
        var currentMiniCart = document.querySelector('.mini-cart');
        if (newMiniCart && currentMiniCart) {
          currentMiniCart.innerHTML = newMiniCart.innerHTML;
        }

        var countEl = temp.querySelector('[data-item-count]');
        var count = countEl ? countEl.getAttribute('data-item-count') : null;
        if (count !== null) {
          document.querySelectorAll('.header__cart-count').forEach(function (el) {
            el.textContent = count;
          });
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
      })
      .catch(function () {});
  }

  // Intercept fetch calls to /cart/* to guarantee 100% two-way sync
  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var url = args[0];
      var isCartMutation = typeof url === 'string' && (
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1
      );

      var promise = originalFetch.apply(this, args);
      if (isCartMutation) {
        promise.then(function (res) {
          if (res && res.ok) {
            scheduleCartSync();
          }
        }).catch(function () {});
      }
      return promise;
    };
  }

  // Listen to Warehouse theme cart events
  ['cart:rerendered', 'cart:refresh', 'product:added', 'theme:loading:end'].forEach(function (evt) {
    document.addEventListener(evt, scheduleCartSync);
  });
  window.addEventListener('pageshow', scheduleCartSync);
  document.addEventListener('DOMContentLoaded', scheduleCartSync);
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    scheduleCartSync();
  }


  /* ==========================================================================
     Web Component: card-qty-selector (Single Variant Products & Modal Rows)
     ========================================================================== */
  class CardQtySelector extends HTMLElement {
    constructor() {
      super();
      this.variantId = this.getAttribute('data-variant-id');
      this.itemKey = this.getAttribute('data-item-key') || '';
      this.productId = this.getAttribute('data-product-id');
      this.baseUnitMin = parseFloat(this.getAttribute('data-base-unit-min')) || 1;
      this.displayUnit = this.getAttribute('data-display-unit') || '';
      if (this.displayUnit === 'meter' && this.baseUnitMin <= 1) {
        this.baseUnitMin = 2;
      }
      this.baseUnit = this.getAttribute('data-base-unit') || '';
      this.displayQty = parseFloat(this.getAttribute('data-display-qty')) || 0;
      this.actualQty = parseInt(this.getAttribute('data-actual-qty'), 10) || 0;
      this.isUpdating = false;

      this.addBtn = this.querySelector('.card-qty-btn--add');
      this.controls = this.querySelector('.card-qty-controls');
      this.minusBtn = this.querySelector('.card-qty-controls__btn--minus');
      this.plusBtn = this.querySelector('.card-qty-controls__btn--plus');
      this.valueSpan = this.querySelector('.card-qty-controls__value');
    }

    connectedCallback() {
      if (this.addBtn) {
        this.addBtn.addEventListener('click', this.addToCart.bind(this));
      }
      if (this.minusBtn) {
        this.minusBtn.addEventListener('click', (e) => this.updateQuantity(e, -1));
      }
      if (this.plusBtn) {
        this.plusBtn.addEventListener('click', (e) => this.updateQuantity(e, 1));
      }
    }

    syncQuantity(displayQty, actualQty, itemKey) {
      if (this.isUpdating) return;
      this.displayQty = displayQty;
      this.actualQty = actualQty;
      if (itemKey) {
        this.itemKey = itemKey;
        this.setAttribute('data-item-key', itemKey);
      }
      this.renderState();
    }

    syncSiblings(displayQty, actualQty, itemKey) {
      var allSame = document.querySelectorAll('card-qty-selector[data-variant-id="' + this.variantId + '"]');
      allSame.forEach((el) => {
        if (el !== this) {
          el.syncQuantity(displayQty, actualQty, itemKey);
        }
      });
    }

    renderState() {
      this.setAttribute('data-display-qty', this.displayQty);
      this.setAttribute('data-actual-qty', this.actualQty);

      if (this.valueSpan) {
        var text = this.displayQty;
        if (this.displayUnit === 'meter') {
          text += 'm';
        }
        this.valueSpan.textContent = text;
      }

      if (this.displayQty > 0) {
        if (this.addBtn) this.addBtn.style.display = 'none';
        if (this.controls) {
          this.controls.style.display = 'flex';
          this.controls.style.opacity = '1';
          this.controls.style.transform = 'scale(1)';
        }
      } else {
        if (this.controls) this.controls.style.display = 'none';
        if (this.addBtn) {
          this.addBtn.style.display = 'flex';
          this.addBtn.style.opacity = '1';
          this.addBtn.style.transform = 'scale(1)';
        }
      }
    }

    addToCart(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.isUpdating) return;
      this.isUpdating = true;

      if (this.addBtn) this.addBtn.classList.add('is-loading');

      var payload = {
        id: this.variantId,
        quantity: this.baseUnitMin
      };

      if (this.displayUnit) {
        payload.properties = {
          _display_unit: this.displayUnit,
          _base_unit_min: this.baseUnitMin
        };
        if (this.baseUnit) {
          payload.properties._base_unit = this.baseUnit;
        }
      }

      var addUrl = (window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (err) { throw err; });
          }
          return r.json();
        })
        .then((response) => {
          if (response.key) {
            this.itemKey = response.key;
            this.setAttribute('data-item-key', this.itemKey);
            window._cartKeyByVariant[String(this.variantId)] = this.itemKey;
          }

          this.displayQty = 1;
          this.actualQty = this.baseUnitMin;

          // Transition animation to quantity controls
          if (this.addBtn) this.addBtn.style.display = 'none';
          if (this.controls) {
            this.controls.style.display = 'flex';
            this.controls.style.opacity = '0';
            this.controls.style.transform = 'scale(0.85)';
            this.controls.getBoundingClientRect(); // reflow
            this.controls.style.transition = 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)';
            this.controls.style.opacity = '1';
            this.controls.style.transform = 'scale(1)';
          }

          this.renderState();
          this.syncSiblings(this.displayQty, this.actualQty, this.itemKey);

          refreshThemeCart();
          scheduleCartSync();
        })
        .catch((err) => {
          console.error('[CardQtySelector] Add to cart error:', err);
        })
        .finally(() => {
          if (this.addBtn) this.addBtn.classList.remove('is-loading');
          this.isUpdating = false;
        });
    }

    updateQuantity(e, change) {
      e.preventDefault();
      e.stopPropagation();

      if (this.isUpdating) return;
      this.isUpdating = true;

      var step = (this.displayUnit === 'meter' || this.baseUnitMin > 1) ? 0.5 : 1;
      var newDisplayQty = 0;

      if (change < 0) {
        if (this.displayQty > 1) {
          newDisplayQty = Math.round((this.displayQty - step) * 10) / 10;
        } else {
          newDisplayQty = 0;
        }
      } else {
        newDisplayQty = Math.round((this.displayQty + step) * 10) / 10;
      }

      var newActualQty = newDisplayQty <= 0 ? 0 : Math.round(newDisplayQty * this.baseUnitMin);

      if (this.controls) this.controls.classList.add('is-loading');

      var targetKey = this.itemKey || (window._cartKeyByVariant && window._cartKeyByVariant[String(this.variantId)]) || this.variantId;
      var changeUrl = (window.routes && window.routes.cartChangeUrl ? window.routes.cartChangeUrl : '/cart/change') + '.js';

      fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: String(targetKey),
          quantity: newActualQty
        })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (err) { throw err; });
          }
          return r.json();
        })
        .then((response) => {
          this.displayQty = Math.max(0, newDisplayQty);
          this.actualQty = newActualQty;

          if (this.displayQty === 0) {
            this.itemKey = '';
            this.removeAttribute('data-item-key');
            delete window._cartKeyByVariant[String(this.variantId)];

            if (this.controls) {
              this.controls.style.transition = 'all 0.2s ease';
              this.controls.style.opacity = '0';
              this.controls.style.transform = 'scale(0.85)';
              setTimeout(() => {
                this.controls.style.display = 'none';
                if (this.addBtn) {
                  this.addBtn.style.display = 'flex';
                  this.addBtn.style.opacity = '0';
                  this.addBtn.style.transform = 'scale(0.85)';
                  this.addBtn.getBoundingClientRect(); // reflow
                  this.addBtn.style.transition = 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)';
                  this.addBtn.style.opacity = '1';
                  this.addBtn.style.transform = 'scale(1)';
                }
              }, 200);
            }
          } else {
            this.renderState();
          }

          this.setAttribute('data-display-qty', this.displayQty);
          this.setAttribute('data-actual-qty', this.actualQty);

          this.syncSiblings(this.displayQty, this.actualQty, this.itemKey);

          if (response && Array.isArray(response.items)) {
            applyCartSync(response);
          } else {
            scheduleCartSync();
          }
          refreshThemeCart();
        })
        .catch((err) => {
          console.error('[CardQtySelector] Update quantity error:', err);
          scheduleCartSync();
        })
        .finally(() => {
          if (this.controls) this.controls.classList.remove('is-loading');
          this.isUpdating = false;
        });
    }
  }

  customElements.define('card-qty-selector', CardQtySelector);


  /* ==========================================================================
     Global Variant Modal System (Popup for "Choose Options")
     ========================================================================== */
  var VariantModal = {
    modalEl: null,
    currentManager: null,

    init: function () {
      if (this.modalEl) return;

      var el = document.createElement('div');
      el.id = 'card-variant-modal';
      el.className = 'cv-modal';
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = [
        '<div class="cv-modal__backdrop" data-action="close"></div>',
        '<div class="cv-modal__dialog" role="dialog" aria-modal="true">',
        '  <div class="cv-modal__header">',
        '    <div class="cv-modal__header-info">',
        '      <h3 class="cv-modal__title"></h3>',
        '      <span class="cv-modal__unit-badge"></span>',
        '    </div>',
        '    <button type="button" class="cv-modal__close" data-action="close" aria-label="Close">✕</button>',
        '  </div>',
        '  <div class="cv-modal__body">',
        '    <div class="cv-modal__list"></div>',
        '  </div>',
        '  <div class="cv-modal__footer">',
        '    <button type="button" class="cv-modal__done-btn" data-action="close">Done</button>',
        '  </div>',
        '</div>'
      ].join('');

      el.querySelectorAll('[data-action="close"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          VariantModal.close();
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && VariantModal.modalEl && VariantModal.modalEl.classList.contains('cv-modal--open')) {
          VariantModal.close();
        }
      });

      document.body.appendChild(el);
      this.modalEl = el;
    },

    open: function (manager) {
      this.init();
      this.currentManager = manager;

      var titleEl = this.modalEl.querySelector('.cv-modal__title');
      var unitBadgeEl = this.modalEl.querySelector('.cv-modal__unit-badge');
      var listEl = this.modalEl.querySelector('.cv-modal__list');

      titleEl.textContent = manager.productTitle || 'Select Options';

      if (manager.displayUnit) {
        unitBadgeEl.textContent = 'Price / ' + manager.displayUnit;
        unitBadgeEl.style.display = 'inline-block';
      } else {
        unitBadgeEl.style.display = 'none';
      }

      listEl.innerHTML = '';

      var variants = manager.getVariants();
      variants.forEach(function (v) {
        var row = document.createElement('div');
        row.className = 'cv-row';
        row.setAttribute('data-variant-id', v.id);

        var imgHtml = v.image
          ? '<img src="' + v.image + '" alt="' + (v.title || '') + '" class="cv-row__img" width="48" height="48" loading="eager" decoding="async">'
          : '<div class="cv-row__img-placeholder"></div>';

        var actionHtml = '';
        if (v.available) {
          actionHtml = [
            '<card-qty-selector',
            '  class="card-qty-selector cv-row__selector"',
            '  data-product-id="' + manager.productId + '"',
            '  data-variant-id="' + v.id + '"',
            '  data-item-key="' + (v.key || '') + '"',
            '  data-actual-qty="' + (v.actual_qty || 0) + '"',
            '  data-display-qty="' + (v.display_qty || 0) + '"',
            '  data-base-unit-min="' + manager.baseUnitMin + '"',
            '  data-display-unit="' + (manager.displayUnit || '') + '"',
            '  data-base-unit="' + (manager.baseUnit || '') + '"',
            '  data-product-title="' + manager.productTitle + ' - ' + v.title + '"',
            '>',
            '  <button type="button" class="card-qty-btn--add" aria-label="Add to cart" style="' + (v.display_qty > 0 ? 'display: none;' : '') + '">',
            '    <span class="card-qty-btn__plus">+</span>',
            '    <span class="card-qty-btn__text">Add</span>',
            '    <span class="card-qty-btn__spinner"></span>',
            '  </button>',
            '  <div class="card-qty-controls" style="' + (v.display_qty === 0 ? 'display: none;' : '') + '">',
            '    <button type="button" class="card-qty-controls__btn card-qty-controls__btn--minus" aria-label="Decrease quantity">',
            '      <span aria-hidden="true">−</span>',
            '    </button>',
            '    <span class="card-qty-controls__value">' + (v.display_qty || 0) + (manager.displayUnit === 'meter' ? 'm' : '') + '</span>',
            '    <button type="button" class="card-qty-controls__btn card-qty-controls__btn--plus" aria-label="Increase quantity">',
            '      <span aria-hidden="true">+</span>',
            '    </button>',
            '  </div>',
            '</card-qty-selector>'
          ].join('');
        } else {
          actionHtml = '<span class="cv-row__sold-out">Sold Out</span>';
        }

        row.innerHTML = [
          '<div class="cv-row__media">' + imgHtml + '</div>',
          '<div class="cv-row__details">',
          '  <span class="cv-row__title">' + v.title + '</span>',
          '  <span class="cv-row__price">' + v.price + (manager.displayUnit ? ' / ' + manager.displayUnit : '') + '</span>',
          '</div>',
          '<div class="cv-row__action">' + actionHtml + '</div>'
        ].join('');

        listEl.appendChild(row);
      });

      this.modalEl.classList.add('cv-modal--open');
      this.modalEl.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cv-modal-active');
    },

    close: function () {
      if (!this.modalEl) return;
      this.modalEl.classList.remove('cv-modal--open');
      this.modalEl.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cv-modal-active');
      this.currentManager = null;
    }
  };

  window.VariantModal = VariantModal;


  /* ==========================================================================
     Web Component: card-variant-manager (Multi-Variant Products)
     ========================================================================== */
  class CardVariantManager extends HTMLElement {
    constructor() {
      super();
      this.productId = this.getAttribute('data-product-id');
      this.baseUnitMin = parseFloat(this.getAttribute('data-base-unit-min')) || 1;
      this.displayUnit = this.getAttribute('data-display-unit') || '';
      if (this.displayUnit === 'meter' && this.baseUnitMin <= 1) {
        this.baseUnitMin = 2;
      }
      this.baseUnit = this.getAttribute('data-base-unit') || '';
      this.productTitle = this.getAttribute('data-product-title') || '';
      this.totalQty = parseFloat(this.getAttribute('data-total-qty')) || 0;
      this.singleVariantId = this.getAttribute('data-single-variant-id') || '';
      this.singleVariantKey = this.getAttribute('data-single-variant-key') || '';

      this.chooseBtn = this.querySelector('.card-qty-btn--choose-options');
      this.controls = this.querySelector('.card-qty-controls--multi');
      this.minusBtn = this.querySelector('[data-action="decrement-multi"]');
      this.plusBtn = this.querySelector('[data-action="increment-multi"]');
      this.valueSpan = this.querySelector('.card-qty-controls__value');
      this.variantsScript = this.querySelector('.card-variants-json');

      this.variants = [];
      if (this.variantsScript) {
        try {
          this.variants = JSON.parse(this.variantsScript.textContent.trim());
        } catch (e) {
          console.error('[CardVariantManager] Error parsing variants JSON:', e);
        }
      }
    }

    connectedCallback() {
      if (this.chooseBtn) {
        this.chooseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openModal();
        });
      }

      var valueWrap = this.querySelector('.card-qty-controls__value-wrap');
      if (valueWrap) {
        valueWrap.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openModal();
        });
      }

      if (this.plusBtn) {
        this.plusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.handlePlus();
        });
      }

      if (this.minusBtn) {
        this.minusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.handleMinus();
        });
      }
    }

    getVariants() {
      return this.variants;
    }

    openModal() {
      VariantModal.open(this);
    }

    handlePlus() {
      if (this.singleVariantId) {
        var v = this.variants.find(item => String(item.id) === String(this.singleVariantId));
        if (v) {
          var step = (this.displayUnit === 'meter' || this.baseUnitMin > 1) ? 0.5 : 1;
          var curDisplay = parseFloat(v.display_qty) || 0;
          var newDisplay = Math.round((curDisplay + step) * 10) / 10;
          var newActual = Math.round(newDisplay * this.baseUnitMin);
          var targetKey = v.key || this.singleVariantKey || (window._cartKeyByVariant && window._cartKeyByVariant[String(v.id)]) || v.id;
          this.changeVariantQty(targetKey, newActual, v, newDisplay);
          return;
        }
      }
      this.openModal();
    }

    handleMinus() {
      if (this.singleVariantId) {
        var v = this.variants.find(item => String(item.id) === String(this.singleVariantId));
        if (v) {
          var step = (this.displayUnit === 'meter' || this.baseUnitMin > 1) ? 0.5 : 1;
          var curDisplay = parseFloat(v.display_qty) || 0;
          var newDisplay = 0;
          if (curDisplay > 1) {
            newDisplay = Math.round((curDisplay - step) * 10) / 10;
          } else {
            newDisplay = 0;
          }
          var newActual = newDisplay <= 0 ? 0 : Math.round(newDisplay * this.baseUnitMin);
          var targetKey = v.key || this.singleVariantKey || (window._cartKeyByVariant && window._cartKeyByVariant[String(v.id)]) || v.id;
          this.changeVariantQty(targetKey, newActual, v, newDisplay);
          return;
        }
      }
      this.openModal();
    }

    changeVariantQty(targetKeyOrId, newActualQty, variantObj, newDisplayQty) {
      if (this.controls) this.controls.classList.add('is-loading');

      // Immediate optimistic update
      if (variantObj && typeof newDisplayQty === 'number') {
        variantObj.display_qty = newDisplayQty;
        variantObj.actual_qty = newActualQty;
        this.totalQty = newDisplayQty;
        this.setAttribute('data-total-qty', this.totalQty);
        if (this.valueSpan) {
          this.valueSpan.textContent = this.totalQty + (this.displayUnit === 'meter' ? 'm' : '');
        }
        if (this.totalQty === 0) {
          if (this.controls) this.controls.style.display = 'none';
          if (this.chooseBtn) this.chooseBtn.style.display = 'flex';
          this.singleVariantId = '';
          this.singleVariantKey = '';
          this.setAttribute('data-single-variant-id', '');
          this.setAttribute('data-single-variant-key', '');
        }
      }

      var changeUrl = (window.routes && window.routes.cartChangeUrl ? window.routes.cartChangeUrl : '/cart/change') + '.js';
      fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: String(targetKeyOrId),
          quantity: newActualQty
        })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (err) { throw err; });
          }
          return r.json();
        })
        .then((updatedCart) => {
          if (updatedCart && Array.isArray(updatedCart.items)) {
            applyCartSync(updatedCart);
          } else {
            scheduleCartSync();
          }
          refreshThemeCart();
        })
        .catch((err) => {
          console.error('[CardVariantManager] Error updating variant:', err);
          scheduleCartSync();
        })
        .finally(() => {
          if (this.controls) this.controls.classList.remove('is-loading');
        });
    }

    syncTotal(qtyByVariant, baseUnitByVariant, displayUnitByVariant, keyByVariant) {
      var newTotal = 0;
      var inCart = [];

      this.variants.forEach((v) => {
        var vIdStr = String(v.id);
        var actual = qtyByVariant[vIdStr] || 0;
        var bMin = this.baseUnitMin;
        if (baseUnitByVariant && baseUnitByVariant[vIdStr]) {
          bMin = baseUnitByVariant[vIdStr];
        }
        var display = calculateDisplayQty(actual, bMin);
        v.actual_qty = actual;
        v.display_qty = display;
        if (keyByVariant && keyByVariant[vIdStr]) {
          v.key = keyByVariant[vIdStr];
        }
        newTotal = Math.round((newTotal + display) * 10) / 10;
        if (display > 0) inCart.push(v);
      });

      this.totalQty = newTotal;
      this.singleVariantId = inCart.length === 1 ? inCart[0].id : '';
      this.singleVariantKey = inCart.length === 1 ? (inCart[0].key || '') : '';

      this.setAttribute('data-total-qty', this.totalQty);
      this.setAttribute('data-single-variant-id', this.singleVariantId);
      this.setAttribute('data-single-variant-key', this.singleVariantKey);

      if (this.valueSpan) {
        var text = this.totalQty;
        if (this.displayUnit === 'meter') {
          text += 'm';
        }
        this.valueSpan.textContent = text;
      }

      if (this.totalQty > 0) {
        if (this.chooseBtn) this.chooseBtn.style.display = 'none';
        if (this.controls) this.controls.style.display = 'flex';
      } else {
        if (this.controls) this.controls.style.display = 'none';
        if (this.chooseBtn) this.chooseBtn.style.display = 'flex';
      }
    }
  }

  customElements.define('card-variant-manager', CardVariantManager);
})();


